// react-router-dom components
import {Link} from 'react-router-dom';

// @mui material components
import Card from '@mui/material/Card';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';

// Authentication layout components
import CoverLayout from 'layouts/authentication/components/CoverLayout';

// Images
import bgImage from 'assets/images/bg-sign-up-cover.jpeg';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {signUpSchema} from 'schemas/auth/signup';

function Cover() {
  const {
    control,
    handleSubmit,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(signUpSchema),
    defaultValues: {
      firstName: '',
      lastName: '',
      username: '',
      email: '',
      password: '',
    },
  });

  const fields = [
    {label: 'First Name', name: 'firstName'},
    {label: 'Last Name', name: 'lastName'},
    {label: 'Username', name: 'username'},
    {label: 'Email', name: 'email'},
    {label: 'Password', name: 'password', type: 'password'},
  ];

  const onSubmit = data => {
    console.log('Form Submitted:', data);
  };

  return (
    <CoverLayout image={bgImage}>
      <Card sx={{marginBottom: '100px'}}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Join us today
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Enter your details to register
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {fields.map((field, index) => (
              <MDBox key={index}>
                <Controller
                  name={field.name}
                  control={control}
                  render={({field: controllerField}) => (
                    <MDInput
                      {...controllerField}
                      fullWidth
                      label={field.label}
                      type={field.type || 'text'}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]?.message}
                      margin="normal"
                    />
                  )}
                />
              </MDBox>
            ))}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                Sign Up
              </MDButton>
            </MDBox>
          </form>

          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Already have an account?{' '}
              <MDTypography
                component={Link}
                to="/authentication/sign-in"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient>
                Sign In
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
